<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<sh-modal
  id="whatsNewModal"
  modal-width="70%"
  modal-height="90%"
  [visible]="isWhatsNewModalVisible"
  sticky
  (modal-closed)="closeWhatsNewModal()"
>
  <sh-access-bar
    *ngIf="screenLayoutService.desktopAny$ | async"
    id="whatsNewAccessBar"
    embedded
  >
    <sh-text slot="functions" size="super-header" style="color: #ec6602">{{
      'label.whatsNew' | translate
    }}</sh-text>
    <sh-icon
      icon="cancel"
      button
      slot="functions"
      size="s"
      (click)="closeWhatsNewModal()"
    ></sh-icon>
  </sh-access-bar>
  <sh-access-bar
    *ngIf="(screenLayoutService.desktopAny$ | async) === false"
    id="whatsNewAccessBar"
    mobile
  >
    <sh-text slot="left" size="super-header" style="color: #ec6602">{{
      'label.whatsNew' | translate
    }}</sh-text>
    <sh-icon
      icon="cancel"
      button
      slot="right"
      size="s"
      (click)="closeWhatsNewModal()"
    ></sh-icon
  ></sh-access-bar>
  <div class="whatsNewContent">
    <sh-pane *ngIf="screenLayoutService.desktopAny$ | async" slot="left">
      <ng-container
        *ngIf="
          featureDetailsService.featureListForSelectedVersion.loading$ | async;
          else features
        "
      >
        <sh-spinner class="feature-loader" size="s"></sh-spinner>
      </ng-container>
      <ng-template #features>
        <sh-list class="featureList" flat>
          <sh-list-item
            *ngFor="let feature of featureList"
            id="feature_{{ feature.featureOrder }}"
            clickable
            divider="full-width"
            (click)="getFeatureDetail(feature)"
            [active]="feature.featureOrder == currentFeatureOrder"
            >{{ feature.featureTitle }}</sh-list-item
          >
        </sh-list>
      </ng-template>
    </sh-pane>

    <div class="featureDetail">
      <div class="carousel-col">
        <ng-container
          *ngIf="
            featureDetailsService.featureImageList.loading$ | async;
            else details
          "
        >
          <sh-spinner class="image-loader" size="l"></sh-spinner>
        </ng-container>
        <ng-template #details>
          <div
            *ngIf="screenLayoutService.desktopAny$ | async"
            class="featuresForPcView"
          >
            <sh-carousel
              arrows
              [counter]="featurePCImages.length > 1"
              element-width="100%"
              *ngIf="featurePCImages.length"
            >
              <div *ngFor="let image of featurePCImages" class="loopPcImage">
                <img
                  alt="image slide"
                  src="data:image/jpeg;base64,{{ image }}"
                />
              </div>
            </sh-carousel>
            <div class="featureContent">
              <sh-text size="super-header">{{ selectedFeatureTitle }}</sh-text>
              <sh-text
                size="14px"
                [innerHTML]="
                  formatFeatureDescription(selectedFeatureDescription)
                "
              >
              </sh-text>
            </div>
          </div>
          <div
            *ngIf="(screenLayoutService.desktopAny$ | async) === false"
            class="featuresForTabletView"
          >
            <sh-carousel
              arrows
              [counter]="featureTabletImages.length > 1"
              element-width="100%"
              *ngIf="featureTabletImages.length"
            >
              <div
                *ngFor="let image of featureTabletImages"
                class="loopTabletImage"
              >
                <img
                  alt="tablet sized image slide"
                  src="data:image/jpeg;base64,{{ image }}"
                />
              </div>
            </sh-carousel>
            <div class="featureContent">
              <sh-text size="super-header">{{ selectedFeatureTitle }}</sh-text>
              <sh-text
                size="14px"
                [innerHTML]="
                  formatFeatureDescription(selectedFeatureDescription)
                "
              >
              </sh-text>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <sh-button
    *ngIf="currentFeatureOrder > 1"
    label="Previous"
    class="PreviousFeature"
    color="secondary"
    slot="footer"
    (click)="getFeatureDetail(featureList[currentFeatureOrder - 2])"
  ></sh-button>
  <sh-button
    *ngIf="currentFeatureOrder < featureList.length"
    label="Next"
    class="nextFeature"
    slot="footer"
    (click)="getFeatureDetail(featureList[currentFeatureOrder])"
  ></sh-button>
</sh-modal>
